import { EKeyCode } from '@/enums/e_key_code';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { WATCHER_SHORTCUT__base } from './WATCHER_SHORTCUT__base';

export function WatcherShortcutAllHintsVisibility() {
  const dispatch = use_dispatch();

  const { hints_shortcut_overlay_with_all_values_visible } = use_slice_ui(['hints_shortcut_overlay_with_all_values_visible']);

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */

  function on_shortcut_pressed() {
    dispatch(LOCAL__ui_set_boolean({ key: 'hints_shortcut_overlay_with_all_values_visible', value: !hints_shortcut_overlay_with_all_values_visible }));

    return true;
  }

  return (
    <>
      <WATCHER_SHORTCUT__base key_codes={[EKeyCode.Slash, EKeyCode.ShiftLeft]} {...{ on_shortcut_pressed }} />
      <WATCHER_SHORTCUT__base key_codes={[EKeyCode.Slash, EKeyCode.ShiftRight]} {...{ on_shortcut_pressed }} />
    </>
  );
}
